import { render } from "./cpt-scroll-text-option.vue?vue&type=template&id=2da6e742"
import script from "./cpt-scroll-text-option.vue?vue&type=script&lang=js"
export * from "./cpt-scroll-text-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__